import { supabase } from '../supabase';

// Shared by the Home screen and LoginPage — both need the exact same OAuth
// call, just with their own local loading/error state around it. On success
// the browser navigates away to Google; there's nothing further to do here,
// App.jsx's existing checkUser()/onAuthStateChange flow picks up the session
// automatically once the user is redirected back.
export async function signInWithGoogle() {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: window.location.origin },
  });
  if (error) throw error;
}
